import ApiService from "@/services/api.service";

const route = "users";

const users = {
    typeProfiles: {
        administrator: 1,
        manager: 2,
        supervisor: 3,
        salesman: 4,
        after_sales: 5
    },
    add(_object) {
        return new Promise((resolve, reject) => {
            ApiService.post(route, _object).then(
                ({ data }) => {
                    resolve(data);
                },
                error => {
                    reject(error);
                }
            );
        });
    },

    all(_params) {
        return new Promise((resolve, reject) => {
            var query = _params ? _params.params : null;
            var params = "";
            var _isPaginate = _params ? _params.isPaginate : false;

            console.log(_params, query)

            if (query != null) {
                params = _params.limit !== undefined ? "?limit=" + _params.limit + "&page=" + _params.currentPage : "";

                if (params == "") {
                    params = "?search=true"
                }
                if (query.branch_id) {
                    params += "&branch_id=" + query.branch_id;
                }
                if (query.profile_id) {
                    params += "&profile_id=" + query.profile_id;
                }
                if (query.type_profile_id) {
                    params += "&type_profile_id=" + query.type_profile_id;
                }
                if (query.textSearch && query.textSearch != "") {
                    params += "&textSearch=" + query.textSearch;
                }
            }

            if(typeof _params == 'string') {
                if(params != '') {
                    params += '&'+_params;
                } else {
                    params = '?'+_params;
                }
            }

            ApiService.get(route + params).then(
                ({ data }) => {
                    if (!_isPaginate) {
                        resolve(data);
                    }
                    else {
                        var props = data.data;
                        props.total = data.total;
                        props.to = data.to;
                        resolve(props);
                    }
                },
                error => {
                    reject(error);
                }
            );
        });
    },

    get(_id) {
        return new Promise((resolve, reject) => {
            ApiService.get(route, _id).then(
                ({ data }) => {
                    resolve(data);
                },
                error => {
                    reject(error);
                }
            );
        });
    },

    getByProfilesId(_params) {
        return new Promise((resolve, reject) => {
            var query = _params ? _params.params : null;
            var params = "";
            var _isPaginate = _params ? _params.isPaginate : false;
            if (query != null) {
                params = _params.limit !== undefined ? "?limit=" + _params.limit + "&page=" + _params.currentPage : "";
                if (query.branch_id) {
                    params += "&branch_id=" + query.branch_id;
                }
                if (query.profile_id) {
                    params += "&profile_id=" + query.profile_id;
                }
                if (query.textSearch && query.textSearch != "") {
                    params += "&textSearch=" + query.textSearch;
                }
            }
            if(typeof _params == 'string') {
                if(params != '') {
                    params += '&'+_params;
                } else {
                    params = '?'+_params;
                }
            }
            ApiService.get(route + "/by-profiles-id"+ params).then(
                ({ data }) => {
                    if (!_isPaginate) {
                        resolve(data);
                    }
                    else {
                        var props = data.data;
                        props.total = data.total;
                        props.to = data.to;
                        resolve(props);
                    }
                },
                error => {
                    reject(error);
                }
            );
        });
    },    

    getByTypeProfile(_typeProfile, _othersFilters) {
        return new Promise((resolve, reject) => {
            ApiService.get(
                route + "/by-type-profile?typeProfile=" + _typeProfile + _othersFilters
            ).then(
                ({ data }) => {
                    resolve(data);
                },
                error => {
                    reject(error);
                }
            );
        });
    },

    getMenu() {
        return new Promise((resolve, reject) => {
            ApiService.get("menu").then(
                response => {
                    resolve(response.data);
                },
                error => {
                    reject(error);
                }
            );
        });
    },

    getPermissionsById(_id) {
        return new Promise((resolve, reject) => {
            ApiService.get(
                route + "/" + _id + "/permissions"
            ).then(
                ({ data }) => {
                    resolve(data);
                },
                error => {
                    reject(error);
                }
            );
        });
    },

    getUserByToken(_token) {
        return new Promise((resolve, reject) => {
            ApiService.get("my-user").then(
                response => {
                    resolve(response.data);
                },
                error => {
                    reject(error);
                }
            );
        });
    },

    refreshToken() {
        return new Promise((resolve, reject) => {
            ApiService.get("refresh-token").then(
                response => {
                    resolve(response.data);
                },
                error => {
                    reject(error);
                }
            );
        });
    },

    login(_username, _password) {
        return new Promise((resolve, reject) => {
            ApiService.post("login", {
                username: _username,
                password: _password
            }).then(
                ({ data }) => {
                    resolve(data);
                },
                error => {
                    reject(error);
                }
            );
        });
    },

    register(
        _name,
        _email,
        _password,
        _passwordConfirmation,
        _firebaseToken = null
    ) {
        return new Promise((resolve, reject) => {
            ApiService.post("register", {
                name: _name,
                email: _email,
                password: _password,
                password_confirmation: _passwordConfirmation,
                firebase_token: _firebaseToken
            }).then(
                ({ data }) => {
                    resolve(data);
                },
                error => {
                    reject(error);
                }
            );
        });
    },

    socialLogin(_firebaseToken) {
        return new Promise((resolve, reject) => {
            ApiService.post("social-login", { firebase_token: _firebaseToken }).then(
                ({ data }) => {
                    resolve(data);
                },
                error => {
                    reject(error);
                }
            );
        });
    },

    rem(_id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(route, _id).then(
                ({ data }) => {
                    resolve(data);
                },
                error => {
                    reject(error);
                }
            );
        });
    },

    patch(_id, _attributes) {
        return new Promise((resolve, reject) => {
            ApiService.patch(route, _id, _attributes).then(({ data }) => {
                resolve(data);
            });
        });
    },

    edit(_id, _attributes) {
        return new Promise((resolve, reject) => {
            ApiService.put(route, _id, _attributes).then(
                ({ data }) => {
                    resolve(data);
                },
                error => {
                    reject(error);
                }
            );
        });
    }
};

export default users;
